export function maskAccountCodeStart(accountInfo) {
    var _a, _b, _c;
    if (!accountInfo)
        return "";
    var parts = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.split("-");
    var hasName = (parts === null || parts === void 0 ? void 0 : parts.length) > 1;
    var name = hasName ? (_a = parts[0]) === null || _a === void 0 ? void 0 : _a.trim() : "";
    var code = hasName ? (_b = parts[1]) === null || _b === void 0 ? void 0 : _b.trim() : (_c = parts[0]) === null || _c === void 0 ? void 0 : _c.trim();
    var lastPart = code === null || code === void 0 ? void 0 : code.slice(-4); // show only last character
    var maskedPart = "x".repeat(Math.max(0, code.length - 1));
    return hasName ? "".concat(name, " - ").concat(lastPart) : "".concat(maskedPart).concat(lastPart);
}
